import Vue from "vue";
import Router from "vue-router";

import ClientForm from "@/components/ClientForm";
import DetailsForm from "@/components/DetailsForm";
import CustomerResearch from "@/components/CustomerResearch";
import CustomerResearchMail from "@/components/CustomerResearchMail";
import ApkForm from "@/components/apk/APKForm";
import RecruitForm from "@/components/RecruitForm";
import wideTemplate from "@/components/partials/misc/wideTemplate";
import narrowTemplate from "@/components/partials/misc/narrowTemplate";
// import holidayTemplate from "@/components/partials/misc/holidayTemplate";
import Holidays from "@/components/Holidays";
import Unsubscribe from "@/components/Unsubscribe";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/recruit",
      component: wideTemplate,
      children: [{ path: "/recruit/:shortcut", component: RecruitForm }],
    },
    {
      path: "/holi",
      component: narrowTemplate,
      children: [{ path: "/holi", component: Holidays }],
    },
    {
      path: "/unsubscribe",
      component: narrowTemplate,
      children: [{ path: "/unsubscribe/:hash", component: Unsubscribe }],
    },
    {
      path: "/",
      component: narrowTemplate,
      children: [
        { path: "/research/:uid", component: CustomerResearch },
        { path: "/mail", component: CustomerResearchMail },
        { path: "/client/apk/:base/:prevent?", component: ApkForm },
        { path: "/:solicitor?", component: ClientForm },
        { path: "/base/:base", component: ClientForm },
        {
          path: "/biznes/:solicitor",
          component: ClientForm,
          meta: { biznes: true },
        },
        { path: "/:base/:solicitor", component: ClientForm },
        { path: "/client/forms/details/:base/:code?", component: DetailsForm },
      ],
    },
  ],
});
